import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Grid from '@material-ui/core/Grid';
import FormLabel from '@material-ui/core/FormLabel';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import { useTranslation } from 'react-i18next';
import useStyles from './styles';
import { validationErrorsMultiLangState } from '../EditTicket/EditTicketSlice';
import { addTicketState } from '../HomePage/ContentTabs/ContentTabsSlice';
import i18n from '../../i18n';
import { userInfoState, actualWorkshopsListState } from '../HomePage/HomeSlice';
import FileUploader from '../AddAnomaly/FileUploader/FileUploader';

function EditTicketGlobalInformations(props) {
  const { createdTicket, expanded, handleChange, saveClicked } = props;
  const classes = useStyles();
  const [priority, setPriority] = React.useState('3');
  const [loadedStatus, setLoadedStatus] = React.useState('unknown');
  const [wagonStatus, setWagonStatus] = React.useState('unblocked');
  const registeredWagonStatus = createdTicket.wagonStatus;
  const [ticketStatus, setTicketStatus] = React.useState('Maintenance in');
  const [ticketType, setTicketType] = React.useState('unplanned');
  const [siteConcerned, setSiteConcerned] = React.useState('-');
  const [description, setDescription] = React.useState('');
  const [lastCargo, setLastCargo] = React.useState('');
  const [statusDate, setStatusDate] = React.useState(new Date());
  const [ticketIncompleteError, setTicketIncompleteError] =
    React.useState(null);
  const [ticketTypeError, setTicketTypeError] = React.useState(null);
  const [attachments, setAttachments] = React.useState([]);
  const [actualWorkshop, setActualWorkshop] = React.useState('-');
  const user = useSelector(userInfoState);
  const actualWorkshopList = useSelector(actualWorkshopsListState);
  const { t } = useTranslation();
  const lang = i18n.language;
  const validationErrorsMultiLang = useSelector(validationErrorsMultiLangState);
  const addTicket = useSelector(addTicketState);
  const isEditDisabled = ticketStatus === 'Ticket closed';

  const dateFormatter = (date) => {
    const isValidDate = Date.parse(date);
    if (Number.isNaN(isValidDate)) {
      return null;
    }
    const offset = date.getTimezoneOffset();
    date = new Date(date.getTime() - offset * 60 * 1000);
    return date.toISOString().split('T')[0];
  };

  const ticketGlobalDetails = {
    ticketNumber: createdTicket.ticketNumber,
    ticketCreationDate: createdTicket.ticketCreationDate,
    ticketStatus,
    ticketType,
    priority,
    statusChangeDescription: description,
    statusDate: dateFormatter(statusDate),
    wagonNumber: createdTicket.wagonNumber,
    productType: createdTicket.productType,
    nextRevisionDate: createdTicket.nextRevisionDate,
    keeper:
      user.internal || user.hasEmilyDRights || user.externalMax
        ? createdTicket.keeper
        : createdTicket.keeperName,
    businessUnit: createdTicket.businessUnit,
    assignedWorkshop: createdTicket.assignedWorkshop,
    loadedStatus,
    wagonStatus,
    siteConcerned:
      (user.internal && !user.hasAllRights) || user.externalMax
        ? user.site
        : siteConcerned,
    ticketCreator: user.name,
    lastCargo,
    attachments,
    actualWorkshop,
  };
  useEffect(() => {
    if (lang === 'fr' && validationErrorsMultiLang.errorsFR !== undefined) {
      setTicketIncompleteError(validationErrorsMultiLang.errorsFR.statusError);
      setTicketTypeError(validationErrorsMultiLang.errorsFR.ticketTypeError);
    } else if (
      lang === 'de' &&
      validationErrorsMultiLang.errorsDE !== undefined
    ) {
      setTicketIncompleteError(validationErrorsMultiLang.errorsDE.statusError);
      setTicketTypeError(validationErrorsMultiLang.errorsDE.ticketTypeError);
    } else if (validationErrorsMultiLang.errorsEN !== undefined) {
      setTicketIncompleteError(validationErrorsMultiLang.errorsEN.statusError);
      setTicketTypeError(validationErrorsMultiLang.errorsEN.ticketTypeError);
    }
  }, [lang, validationErrorsMultiLang]);

  useEffect(() => {
    if (createdTicket.ticketStatus) {
      setTicketStatus(createdTicket.ticketStatus);
    }
    if (createdTicket.ticketType) {
      setTicketType(createdTicket.ticketType);
    }
    if (createdTicket.priority) {
      setPriority(createdTicket.priority);
    }
    if (createdTicket.loadedStatus) {
      setLoadedStatus(createdTicket.loadedStatus);
    }
    if (createdTicket.wagonStatus) {
      setWagonStatus(createdTicket.wagonStatus);
    }
    if (createdTicket.siteConcerned) {
      setSiteConcerned(createdTicket.siteConcerned);
    }
    if (createdTicket.lastCargo && createdTicket.lastCargo !== '-') {
      setLastCargo(createdTicket.lastCargo);
    }
    if (createdTicket.attachments) {
      setAttachments(createdTicket.attachments.slice());
    }
    if (createdTicket.actualWorkshop) {
      setActualWorkshop(createdTicket.actualWorkshop);
    }
  }, [createdTicket]);

  useEffect(() => {
    props.setTicketInformations(ticketGlobalDetails);
  }, [
    ticketStatus,
    ticketType,
    priority,
    description,
    loadedStatus,
    wagonStatus,
    siteConcerned,
    statusDate,
    lastCargo,
    attachments,
    actualWorkshop,
  ]);
  function getAttachments(files) {
    setAttachments(files.slice());
  }
  function getAttachmentsWithFile(files) {
    if (saveClicked) {
      props.sendAttachmentWithFiles(files);
    }
  }

  return (
    <div>
      <Accordion
        className={classes.accordion}
        expanded={expanded}
        onChange={handleChange}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon className={classes.expandIcon} />}
        >
          <Typography className={classes.heading}>
            {t('Global maintenance ticket details')}
          </Typography>
          <Typography className={classes.secondaryHeading}>
            {t('Ticket and wagon main details')}
          </Typography>
        </AccordionSummary>
        <AccordionDetails style={{ display: 'block' }}>
          {
            <div className={classes.description}>
              <span className={classes.asterisk}> * </span>
              {t('edit ticket description')}
            </div>
          }
          {user.internal || user.hasEmilyDRights || user.externalMax ? (
            <div
              aria-label="internal user global ticket details"
              className={classes.container}
            >
              <Grid container spacing={1} className={classes.gridMargin}>
                <Grid item xs={3}>
                  <FormLabel className={classes.formLabel} disabled>
                    {t('Ticket Number')}
                  </FormLabel>
                </Grid>
                <Grid item xs={3}>
                  <FormLabel className={classes.formLabel} disabled>
                    {t('Ticket creation date')}
                  </FormLabel>
                </Grid>
                <Grid item xs={3}>
                  <FormLabel className={classes.formLabel}>
                    {t('Ticket Type')}
                    {user.hasAllRights &&
                      (createdTicket.ticketType !== 'planned' ||
                        (createdTicket.anomalies &&
                          createdTicket.anomalies.length !== 0)) && (
                        <span className={classes.asterisk}> *</span>
                      )}
                  </FormLabel>
                </Grid>
                <Grid item xs={3}>
                  <FormLabel className={classes.formLabel}>
                    {t('Priority')}
                    <span className={classes.asterisk}> *</span>
                  </FormLabel>
                </Grid>
                <Grid item xs={3}>
                  <TextField
                    disabled
                    className={classes.input}
                    variant="outlined"
                    size="small"
                    value={createdTicket.ticketNumber}
                  />
                </Grid>
                <Grid item xs={3}>
                  {' '}
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      className={classes.datePicker}
                      InputProps={{ className: classes.input }}
                      disabled
                      disableToolbar
                      inputVariant="outlined"
                      format="dd/MM/yyyy"
                      margin="normal"
                      value={createdTicket.ticketCreationDate}
                    />
                  </MuiPickersUtilsProvider>
                </Grid>
                <Grid item xs={3}>
                  <FormControl className={classes.formControl}>
                    <Select
                      disabled={
                        !user.hasAllRights ||
                        (createdTicket.ticketType === 'planned' &&
                          !(
                            createdTicket.anomalies &&
                            createdTicket.anomalies.length !== 0
                          )) ||
                        isEditDisabled
                      }
                      error={ticketTypeError !== null}
                      variant="outlined"
                      value={ticketType}
                      onChange={(e) => {
                        setTicketType(e.target.value);
                        setTicketTypeError(null);
                        if (ticketTypeError != null) {
                          props.resetValidationErrors('ticketTypeError');
                        }
                      }}
                      displayEmpty
                      className={classes.select}
                      inputProps={{ 'aria-label': 'Without label' }}
                      MenuProps={{ classes: { paper: classes.dropdownStyle } }}
                    >
                      <MenuItem value="planned">{t('planned')}</MenuItem>
                      <MenuItem value="unplanned">{t('unplanned')}</MenuItem>
                    </Select>
                    <FormHelperText className={classes.formHelperText}>
                      {ticketTypeError}
                    </FormHelperText>
                  </FormControl>
                </Grid>
                <Grid item xs={3}>
                  <FormControl className={classes.formControl}>
                    <Select
                      disabled={isEditDisabled}
                      variant="outlined"
                      value={priority}
                      onChange={(e) => {
                        setPriority(e.target.value);
                      }}
                      displayEmpty
                      className={classes.select}
                      inputProps={{ 'aria-label': 'Without label' }}
                      MenuProps={{ classes: { paper: classes.dropdownStyle } }}
                    >
                      <MenuItem value={1}>1 HIGH</MenuItem>
                      <MenuItem value={2}>2 MEDIUM</MenuItem>
                      <MenuItem value={3}>3 LOW</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
              <Grid container spacing={1} className={classes.gridMargin}>
                <Grid item xs={6}>
                  <FormLabel className={classes.formLabel}>
                    {t('Ticket status')}
                    <span className={classes.asterisk}> *</span>
                  </FormLabel>
                </Grid>

                <Grid item xs={3}>
                  <FormLabel className={classes.formLabel}>
                    {t('Status change date')}
                    <span className={classes.asterisk}> *</span>
                  </FormLabel>
                </Grid>

                <Grid item xs={3}>
                  <FormLabel className={classes.formLabel}>
                    {t('Actual workshop')}
                  </FormLabel>
                </Grid>

                <Grid item xs={6}>
                  <FormControl className={classes.formControlTicketStatus}>
                    <Select
                      disabled={isEditDisabled}
                      variant="outlined"
                      value={ticketStatus}
                      onChange={(e) => {
                        setTicketStatus(e.target.value);
                        setTicketIncompleteError(null);
                        if (ticketIncompleteError != null) {
                          props.resetValidationErrors('statusError');
                        }
                      }}
                      error={ticketIncompleteError !== null}
                      displayEmpty
                      className={classes.select}
                      inputProps={{ 'aria-label': 'Without label' }}
                      MenuProps={{
                        classes: { paper: classes.dropdownStyle },
                      }}
                    >
                      <MenuItem disabled value="ticket incomplete">
                        {t('ticket incomplete')}
                      </MenuItem>
                      <MenuItem value="Maintenance in">
                        {t('Maintenance in')}
                      </MenuItem>
                      <MenuItem value="Awaiting keeper feedback">
                        {t('Awaiting keeper feedback')}
                      </MenuItem>
                      <MenuItem value="Transport order">
                        {t('Transport order')}
                      </MenuItem>
                      <MenuItem value="Transport">{t('Transport')}</MenuItem>
                      <MenuItem value="Cleaning">{t('Cleaning')}</MenuItem>
                      <MenuItem value="Workshop"> {t('Workshop')}</MenuItem>
                      <MenuItem value="Maintenance completed, waiting for transport order">
                        {t(
                          'Maintenance completed, waiting for transport order',
                        )}
                      </MenuItem>
                      <MenuItem value="Awaiting mobile maintenance">
                        {t('Awaiting mobile maintenance')}
                      </MenuItem>
                      <MenuItem value="Mobile maintenance completed">
                        {t('Mobile maintenance completed')}
                      </MenuItem>
                      <MenuItem value="Last transport">
                        {t('Last transport')}
                      </MenuItem>
                      <MenuItem value="Ticket closed">
                        {t('Ticket closed')}
                      </MenuItem>
                    </Select>
                    <FormHelperText className={classes.formHelperText}>
                      {ticketIncompleteError}
                    </FormHelperText>
                  </FormControl>
                </Grid>
                <Grid item xs={3}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      disabled={isEditDisabled}
                      className={classes.datePicker}
                      InputProps={{ className: classes.datePickerInput }}
                      disableToolbar
                      inputVariant="outlined"
                      format="dd/MM/yyyy"
                      margin="normal"
                      value={statusDate}
                      onChange={(date) => {
                        setStatusDate(date);
                      }}
                    />
                  </MuiPickersUtilsProvider>{' '}
                </Grid>

                <Grid item xs={3}>
                  <Select
                    onChange={(e) => {
                      setActualWorkshop(e.target.value);
                    }}
                    variant="outlined"
                    value={actualWorkshop}
                    className={classes.select}
                    inputProps={{ 'aria-label': 'Without label' }}
                    MenuProps={{ classes: { paper: classes.dropdownStyle } }}
                  >
                    {actualWorkshopList &&
                      actualWorkshopList.length > 0 &&
                      actualWorkshopList.map((workshop) => (
                        <MenuItem
                          key={workshop.workshopsName}
                          value={workshop.workshopsName}
                        >
                          {workshop.workshopsName}
                        </MenuItem>
                      ))}
                  </Select>
                </Grid>
              </Grid>
              {!addTicket && (
                <Grid container spacing={1} className={classes.gridMargin}>
                  <Grid item xs={12}>
                    <FormLabel className={classes.formLabel}>
                      {t('Status changes description')}
                    </FormLabel>
                  </Grid>
                  <Grid item xs={12}>
                    {' '}
                    <TextField
                      disabled={isEditDisabled}
                      className={classes.ticketdetail}
                      fullWidth
                      value={description}
                      onChange={(e) => {
                        setDescription(e.target.value.slice(0, 255));
                      }}
                      placeholder={t('Enter Status changes description')}
                      multiline
                      rows={3}
                      InputProps={{
                        classes: { input: classes.inputStyle },
                      }}
                      variant="outlined"
                    />
                  </Grid>
                </Grid>
              )}
              <Grid container spacing={1} className={classes.gridMargin}>
                <Grid item xs={3}>
                  <FormLabel className={classes.formLabel} disabled>
                    {t('Wagon number')}
                  </FormLabel>
                </Grid>
                <Grid item xs={3}>
                  <FormLabel className={classes.formLabel} disabled>
                    {t('Keeper')}{' '}
                  </FormLabel>
                </Grid>
                <Grid item xs={3}>
                  <FormLabel className={classes.formLabel} disabled>
                    {t('Next scheduled revision date')}
                  </FormLabel>
                </Grid>
                <Grid item xs={3}>
                  <FormLabel className={classes.formLabel} disabled>
                    {t('Assigned workshop')}
                  </FormLabel>
                </Grid>
                <Grid item xs={3}>
                  <TextField
                    disabled
                    className={classes.input}
                    variant="outlined"
                    size="small"
                    value={createdTicket.wagonNumber}
                  />
                </Grid>
                <Grid item xs={3}>
                  <TextField
                    disabled
                    className={classes.input}
                    variant="outlined"
                    size="small"
                    value={createdTicket.keeper}
                  />
                </Grid>
                <Grid item xs={3}>
                  {' '}
                  {createdTicket.nextRevisionDate !== '-' ? (
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <KeyboardDatePicker
                        className={classes.datePicker}
                        InputProps={{ className: classes.input }}
                        disabled
                        disableToolbar
                        inputVariant="outlined"
                        format="dd/MM/yyyy"
                        margin="normal"
                        id="date-picker-inline"
                        value={createdTicket.nextRevisionDate}
                      />
                    </MuiPickersUtilsProvider>
                  ) : (
                    <TextField
                      disabled
                      className={classes.input}
                      variant="outlined"
                      size="small"
                      value={createdTicket.nextRevisionDate}
                    />
                  )}
                </Grid>
                <Grid item xs={3}>
                  <TextField
                    disabled
                    className={classes.input}
                    variant="outlined"
                    size="small"
                    value={createdTicket.assignedWorkshop}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={1} className={classes.gridMargin}>
                <Grid item xs={3}>
                  <FormLabel className={classes.formLabel} disabled>
                    {t('Product type')}
                  </FormLabel>
                </Grid>
                <Grid item xs={3}>
                  <FormLabel className={classes.formLabel} disabled>
                    {t('Business unit')}
                  </FormLabel>
                </Grid>
                <Grid item xs={3} />
                <Grid item xs={3}>
                  <FormLabel className={classes.formLabel}>
                    {t('Site concerned')}
                  </FormLabel>
                </Grid>
                <Grid item xs={3}>
                  <TextField
                    disabled
                    className={classes.input}
                    variant="outlined"
                    size="small"
                    value={createdTicket.productType}
                  />
                </Grid>
                <Grid item xs={3}>
                  <TextField
                    disabled
                    className={classes.businessUnit}
                    variant="outlined"
                    size="small"
                    value={createdTicket.businessUnit}
                  />
                </Grid>
                <Grid item xs={3} />
                <Grid item xs={3}>
                  {user.hasAllRights || user.hasEmilyDRights ? (
                    <Select
                      disabled={isEditDisabled}
                      variant="outlined"
                      value={siteConcerned}
                      onChange={(e) => {
                        setSiteConcerned(e.target.value);
                      }}
                      displayEmpty
                      className={classes.select}
                      inputProps={{ 'aria-label': 'Without label' }}
                      MenuProps={{
                        classes: { paper: classes.dropdownStyle },
                      }}
                    >
                      <MenuItem value="" disabled>
                        Select a site
                      </MenuItem>
                      <MenuItem value="-">-</MenuItem>
                      <MenuItem value="leuna">Leuna</MenuItem>
                      <MenuItem value="normandy"> {t('normandy')}</MenuItem>
                      <MenuItem value="feyzin">Feyzin</MenuItem>
                      <MenuItem value="lavéra">Lavéra</MenuItem>
                      <MenuItem value="donges">Donges</MenuItem>
                      <MenuItem value="carling">Carling</MenuItem>
                    </Select>
                  ) : (
                    <TextField
                      disabled
                      className={classes.input}
                      inputProps={{ style: { textTransform: 'capitalize' } }}
                      variant="outlined"
                      size="small"
                      value={t(createdTicket.siteConcerned) || t(user.site)}
                    />
                  )}
                </Grid>
              </Grid>
              <Grid container spacing={1} className={classes.gridMargin}>
                <Grid item xs={3}>
                  <FormLabel className={classes.formLabel}>
                    {t('Loaded status')}
                    <span className={classes.asterisk}> *</span>
                  </FormLabel>
                </Grid>
                <Grid item xs={3}>
                  <FormLabel className={classes.formLabel}>
                    {t('(Last) Cargo')}
                  </FormLabel>
                </Grid>
                <Grid item xs={3} />
                <Grid item xs={3}>
                  <FormLabel className={classes.formLabel}>
                    {t('Wagon status')}
                    {(user.hasBlacklistRights ||
                      user.hasEmilyDRights ||
                      registeredWagonStatus === 'unblocked' ||
                      addTicket) && (
                      <span className={classes.asterisk}> *</span>
                    )}
                  </FormLabel>
                </Grid>
                <Grid item xs={3}>
                  <FormControl className={classes.formControl}>
                    <Select
                      disabled={isEditDisabled}
                      variant="outlined"
                      value={loadedStatus}
                      onChange={(e) => {
                        setLoadedStatus(e.target.value);
                      }}
                      displayEmpty
                      className={classes.select}
                      inputProps={{ 'aria-label': 'Without label' }}
                      MenuProps={{
                        classes: { paper: classes.dropdownStyle },
                      }}
                    >
                      <MenuItem value="loaded">{t('loaded')}</MenuItem>
                      <MenuItem value="empty"> {t('empty')}</MenuItem>
                      <MenuItem value="empty under product">
                        {t('empty under product')}
                      </MenuItem>
                      <MenuItem value="empty under nitrogen">
                        {t('empty under nitrogen')}
                      </MenuItem>
                      <MenuItem value="empty under air">
                        {t('empty under air')}
                      </MenuItem>
                      <MenuItem value="unknown">{t('unknown')}</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={3}>
                  <TextField
                    disabled={isEditDisabled}
                    className={classes.cargoInput}
                    variant="outlined"
                    size="small"
                    placeholder={t('Enter (last) cargo')}
                    InputProps={{ classes: { input: classes.inputStyle } }}
                    value={lastCargo || ''}
                    onChange={(e) => {
                      setLastCargo(e.target.value);
                    }}
                  />
                </Grid>
                <Grid item xs={3} />
                <Grid item xs={3}>
                  {user.hasBlacklistRights ||
                  user.hasEmilyDRights ||
                  registeredWagonStatus === 'unblocked' ||
                  addTicket ? (
                    <FormControl className={classes.formControl}>
                      <Select
                        disabled={isEditDisabled}
                        variant="outlined"
                        value={wagonStatus}
                        onChange={(e) => {
                          setWagonStatus(e.target.value);
                        }}
                        displayEmpty
                        className={classes.select}
                        inputProps={{ 'aria-label': 'Without label' }}
                        MenuProps={{
                          classes: { paper: classes.dropdownStyle },
                        }}
                      >
                        <MenuItem value="blocked">{t('blocked')}</MenuItem>
                        <MenuItem value="unblocked">{t('unblocked')}</MenuItem>
                      </Select>
                    </FormControl>
                  ) : (
                    <TextField
                      disabled
                      className={classes.input}
                      inputProps={{ style: { textTransform: 'capitalize' } }}
                      variant="outlined"
                      size="small"
                      value={t(wagonStatus)}
                    />
                  )}
                </Grid>
              </Grid>
              <FileUploader
                sendAttachmentWithFiles={getAttachmentsWithFile}
                sendAttachments={getAttachments}
                saveClicked={saveClicked}
                files={
                  createdTicket.attachments
                    ? createdTicket.attachments.slice()
                    : []
                }
                anomalyIndex="0"
              />
            </div>
          ) : (
            <div
              aria-label="internal user global ticket details"
              className={classes.container}
            >
              <Grid container spacing={1} className={classes.gridMargin}>
                <Grid item xs={4}>
                  <FormLabel className={classes.formLabel} disabled>
                    {t('Ticket Number')}
                  </FormLabel>
                </Grid>
                <Grid item xs={4}>
                  <FormLabel className={classes.formLabel} disabled>
                    {t('Ticket creation date')}
                  </FormLabel>
                </Grid>
                <Grid item xs={4}>
                  <FormLabel className={classes.formLabel} disabled>
                    {t('Wagon number')}
                  </FormLabel>
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    disabled
                    className={classes.input}
                    variant="outlined"
                    size="small"
                    value={createdTicket.ticketNumber}
                  />
                </Grid>
                <Grid item xs={4}>
                  {' '}
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      className={classes.datePicker}
                      InputProps={{ className: classes.input }}
                      disabled
                      disableToolbar
                      inputVariant="outlined"
                      format="dd/MM/yyyy"
                      margin="normal"
                      value={createdTicket.ticketCreationDate}
                    />
                  </MuiPickersUtilsProvider>
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    disabled
                    className={classes.input}
                    variant="outlined"
                    size="small"
                    value={createdTicket.wagonNumber}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={1} className={classes.gridMargin}>
                <Grid item xs={3}>
                  <FormLabel className={classes.formLabel}>
                    {t('Loaded status')}
                    <span className={classes.asterisk}> *</span>
                  </FormLabel>
                </Grid>
                <Grid item xs={3}>
                  <FormLabel className={classes.formLabel} disabled>
                    {t('Keeper')}
                  </FormLabel>
                </Grid>
                <Grid item xs={3}>
                  <FormLabel className={classes.formLabel} disabled>
                    {t('Product type')}
                  </FormLabel>
                </Grid>
                <Grid item xs={3}>
                  <FormLabel className={classes.formLabel}>
                    {t('(Last) Cargo')}
                  </FormLabel>
                </Grid>
                <Grid item xs={3}>
                  <FormControl className={classes.formControl}>
                    <Select
                      variant="outlined"
                      value={loadedStatus}
                      onChange={(e) => {
                        setLoadedStatus(e.target.value);
                      }}
                      displayEmpty
                      className={classes.select}
                      inputProps={{ 'aria-label': 'Without label' }}
                      MenuProps={{ classes: { paper: classes.dropdownStyle } }}
                    >
                      <MenuItem value="loaded">{t('loaded')}</MenuItem>
                      <MenuItem value="empty"> {t('empty')}</MenuItem>
                      <MenuItem value="empty under product">
                        {t('empty under product')}
                      </MenuItem>
                      <MenuItem value="empty under nitrogen">
                        {t('empty under nitrogen')}
                      </MenuItem>
                      <MenuItem value="empty under air">
                        {t('empty under air')}
                      </MenuItem>
                      <MenuItem value="unknown">{t('unknown')}</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={3}>
                  <TextField
                    disabled
                    className={classes.input}
                    variant="outlined"
                    size="small"
                    value={createdTicket.keeperName}
                  />
                </Grid>
                <Grid item xs={3}>
                  <TextField
                    disabled
                    className={classes.input}
                    variant="outlined"
                    size="small"
                    value={createdTicket.productType}
                  />
                </Grid>
                <Grid item xs={3}>
                  <TextField
                    className={classes.cargoInput}
                    variant="outlined"
                    size="small"
                    placeholder={t('Enter (last) cargo')}
                    InputProps={{ classes: { input: classes.inputStyle } }}
                    value={lastCargo || ''}
                    onChange={(e) => {
                      setLastCargo(e.target.value);
                    }}
                  />
                </Grid>
              </Grid>
            </div>
          )}
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
export default EditTicketGlobalInformations;
